import React, { useState, useEffect, useRef } from 'react'
import styles from './order-list.module.scss'
import moment from 'moment'
import { PAGE_SIZE, PAGE_SIZE_OPTIONS } from 'consts'
import { compare, formatCash, tableSum } from 'utils'
import { useReactToPrint } from 'react-to-print'

//antd
import { Input, Button, Row, Table, Select, Space } from 'antd'

//icons
import { SearchOutlined, ToTopOutlined } from '@ant-design/icons'

//components
import PrintOrder from 'components/print/print-order'
import FilterDate from 'components/filter-date'
import ExportCSV from 'components/ExportCSV/export'
import FilterRegion from 'components/filter-region'

//apis
import { getBookings } from 'apis/booking'
import { getBranches } from 'apis/branch'

import { useTranslation } from 'react-i18next'

export default function OrderList() {
  const { t } = useTranslation()
  let printOrderRef = useRef()
  const typingTimeoutRef = useRef(null)
  const handlePrint = useReactToPrint({
    content: () => printOrderRef.current,
  })

  const [dataPrint, setDataPrint] = useState(null)

  const [loading, setLoading] = useState(false)
  const [branches, setBranches] = useState([])
  const [orders, setOrders] = useState([])
  const [countOrder, setCountOrder] = useState(0)

  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: PAGE_SIZE })
  const [valueSearch, setValueSearch] = useState('')
  const [valueSearchName, setValueSearchName] = useState('')

  const Print = () => (
    <div style={{ display: 'none' }}>
      <PrintOrder ref={printOrderRef} data={dataPrint} />
    </div>
  )

  const _onSearch = (e) => {
    const value = e.target.value
    setValueSearch(value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      paramsFilter.page = 1

      if (value) paramsFilter.booking_id = value
      else delete paramsFilter.booking_id

      setParamsFilter({ ...paramsFilter })
    }, 650)
  }
  const _onSearchName = (e) => {
    const value = e.target.value
    setValueSearchName(value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      paramsFilter.page = 1

      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      setParamsFilter({ ...paramsFilter })
    }, 650)
  }

  const _onChangeDate = (date, dateString) => {
    paramsFilter.page = 1

    if (date) {
      paramsFilter.from_date = dateString[0]
      paramsFilter.to_date = dateString[1]
    } else {
      delete paramsFilter.from_date
      delete paramsFilter.to_date
    }

    setParamsFilter({ ...paramsFilter })
  }

  const _onChangeStatus = (value) => {
    paramsFilter.page = 1

    if (value) paramsFilter.bill_status = value
    else delete paramsFilter.bill_status

    setParamsFilter({ ...paramsFilter })
  }

  const _clearFilters = () => {
    setParamsFilter({ page: 1, page_size: 20 })
    setValueSearch('')
    setValueSearchName('')
  }

  const columnsOrder = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      width: 20,
    },
    {
      title: 'Mã bàn',
      dataIndex: 'code',
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Tên khách hàng',
      render: (text, record) => record.full_name,
      // sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Chi nhánh',
      render: (text, record) => (record.branch_info ? record.branch_info.name : ''),
      // sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Quy mô bữa tiệc',
      render: (text, record) => (
        <p style={{ textAlign: 'center', margin: 0 }}>
          {record.number_people ? record.number_people : ''}
        </p>
      ),
      sorter: (a, b) => compare(a, b, 'number_people'),
    },
    {
      title: 'Ghi chú',
      dataIndex: 'note',
      render: (text, record) => (record.note ? record.note : ''),
      sorter: (a, b) => compare(a, b, 'note'),
    },
    {
      title: 'Liên hệ',
      dataIndex: 'phone',
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Ngày khách hẹn',
      dataIndex: 'date',
      render: (text, record) => text && moment(text).format('DD/MM/YY'),
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
    },
    {
      title: 'Giờ khách hẹn',
      dataIndex: 'time',
      render: (text, record) => text && text,
      sorter: (a, b) => moment(a.time).unix() - moment(b.time).unix(),
    },
    // {
    //   title: t('order_list.customer_code'),
    //   sorter: (a, b) =>
    //     compareCustom(
    //       a.customer ? `${a.customer.first_name} ${a.customer.last_name}` : '',
    //       b.customer ? `${b.customer.first_name} ${b.customer.last_name}` : ''
    //     ),
    //   render: (text, record) =>
    //     record.customer ? `${record.customer.first_name} ${record.customer.last_name}` : '',
    // },
    // {
    //   title: t('order_list.employee'),
    //   sorter: (a, b) =>
    //     compareCustom(
    //       a.employee ? `${a.employee.first_name} ${a.employee.last_name}` : '',
    //       a.employee ? `${b.employee.first_name} ${b.employee.last_name}` : ''
    //     ),

    //   render: (text, record) =>
    //     record.employee ? `${record.employee.first_name} ${record.employee.last_name}` : '',
    // },
    // {
    //   title: t('order_list.order_status'),
    //   dataIndex: 'bill_status',
    //   sorter: (a, b) => compare(a, b, 'bill_status'),
    // },
    // {
    //   title: t('order_list.payment'),
    //   dataIndex: 'payment_status',
    //   sorter: (a, b) => compare(a, b, 'payment_status'),
    // },
    // {
    //   title: t('order_list.guest_must_pay'),
    //   dataIndex: 'final_cost',
    //   sorter: (a, b) => compare(a, b, 'final_cost'),

    //   render: (text) => formatCash(text),
    // },
  ]

  const columnsProduct = [
    {
      title: t('order_list.food_code'),
      dataIndex: 'product_id',
      sorter: (a, b) => compare(a, b, 'product_id'),
    },
    {
      title: t('common.image'),
      dataIndex: 'image',
      render: (data) => (
        <img src={data && data[0]} style={{ maxWidth: 60, maxHeight: 60 }} alt="" />
      ),
    },
    {
      title: t('order_listfood_name'),
      dataIndex: 'title',
      sorter: (a, b) => compare(a, b, 'title'),
    },
    {
      title: t('order_list.quantity'),
      dataIndex: 'quantity',
      sorter: (a, b) => compare(a, b, 'quantity'),
    },
    {
      title: t('order_list.unit_code'),
      sorter: (a, b) => compare(a, b, 'price'),

      render: (text, record) => (record.price ? formatCash(+record.price) : 0),
    },
    {
      title: t('order_list.discount'),
      sorter: (a, b) => compare(a, b, 'discount'),

      render: (text, record) => (record.discount ? formatCash(+record.discount) : 0),
    },
    {
      title: t('order_list.into_money'),
      sorter: (a, b) => compare(a, b, 'total_cost'),
      render: (text, record) => (record.total_cost ? formatCash(+record.total_cost) : 0),
    },
  ]

  const _getBranches = async (params) => {
    try {
      const res = await getBranches(params)
      if (res.status === 200) {
        setBranches(res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const _getBookings = async (params) => {
    try {
      setLoading(true)
      const res = await getBookings(params)
      if (res.status === 200) {
        setOrders(res.data.data)
        setCountOrder(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const _getTableToExport = async () => {
    let dataExport = []
    try {
      setLoading(true)
      const res = await getBookings()
      if (res.status === 200) {
        dataExport = res.data.data.map((item, index) => ({
          STT: index + 1,
          'Mã bàn': item.code || '',
          'Tên khách hàng': item.full_name || '',
          'Chi nhánh': item.branch_info.name || '',
          'Quy mô bữa tiệc': item.number_people || '',
          'Ghi chú': item.note || '',
          'Liên hệ': item.phone || '',
          'E-mail': item.email || '',
          'Ngày đặt': item.create_date ? moment(item.create_date).format('DD-MM-YYYY') : '',
          'Giờ đặt': item.create_date ? moment(item.create_date).format('HH:mm') : '',
        }))
      }
      setLoading(false)
      ExportCSV(dataExport, 'Đơn đặt bàn')
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    _getBranches()
  }, [])

  useEffect(() => {
    _getBookings(paramsFilter)
  }, [paramsFilter])

  return (
    <>
      <Print />
      <div className={`${styles['promotion_manager']} ${styles['card']}`}>
        <Row
          justify="space-between"
          wrap={false}
          align="middle"
          style={{
            borderBottom: '1px solid rgb(236, 226, 226)',
            paddingBottom: '0.75rem',
            width: '100%',
          }}
        >
          <h3 style={{ marginBottom: 0, fontSize: 19 }}>Quản lý đặt bàn</h3>
          <Button onClick={_getTableToExport} size="large" type="primary" icon={<ToTopOutlined />}>
            Xuất Excel
          </Button>
          {/* <Permissions permissions={[PERMISSIONS.tao_don_hang]}>
            <Button
              onClick={() => history.push(ROUTES.ORDER_CREATE)}
              size="large"
              type="primary"
              icon={<PlusCircleOutlined />}
            >
              Tạo đơn hàng
            </Button>
          </Permissions> */}
        </Row>

        <div style={{ marginTop: '1rem', width: '100%' }}>
          <Space>
            <div>
              {/* <div>Tìm kiếm theo mã bàn</div> */}
              <Input
                style={{ width: 350 }}
                prefix={<SearchOutlined />}
                size="large"
                name="booking_id"
                value={valueSearch}
                onChange={_onSearch}
                placeholder="Nhập mã bàn"
                allowClear
              />
            </div>
            <div>
              {/* <div>Tìm kiếm theo tên khách hàng</div> */}
              <Input
                style={{ width: 350 }}
                prefix={<SearchOutlined />}
                size="large"
                name="name"
                value={valueSearchName}
                onChange={_onSearchName}
                placeholder="Nhập tên khách hàng"
                allowClear
              />
            </div>
            <div>
              {/* <div>{t('common.filter_by_time')}</div> */}
              <FilterDate
                width={270}
                size="large"
                paramsFilter={paramsFilter}
                setParamsFilter={setParamsFilter}
              />
            </div>

            <Button
              style={{ display: Object.keys(paramsFilter).length < 3 && 'none' }}
              size="large"
              onClick={_clearFilters}
              type="primary"
              danger
            >
              Xóa bộ lọc
            </Button>
            {/* <div>
              <div>{t('order_list.filter_by_status')}</div>
              <Select
                value={paramsFilter.value}
                onChange={_onChangeStatus}
                showSearch
                size="large"
                allowClear
                placeholder={t('order_list.choose_status')}
                style={{ width: 250 }}
              >
                {Object.keys(BILL_STATUS_ORDER).map((status, index) => (
                  <Select.Option value={status} key={index}>
                    {status}
                  </Select.Option>
                ))}
              </Select>
            </div> */}
          </Space>
          <div style={{ marginTop: 10 }}>
            <FilterRegion
              width_size={350}
              setParamsFilter={setParamsFilter}
              paramsFilter={paramsFilter}
            />
          </div>
        </div>

        <Table
          size="small"
          rowKey="_id"
          loading={loading}
          // rowSelection={{
          //   selectedRowKeys,
          //   onChange: (keys) => setSelectedRowKeys(keys),
          // }}
          // expandable={{
          //   expandedRowRender: (record) => {
          //     return (
          //       <div style={{ padding: '17px 10px' }}>
          //         <Row wrap={false}>
          //           <div
          //             style={{
          //               width: 'calc(100% - 165px)',
          //               backgroundColor: '#FFFFFF',
          //               borderRadius: 5,
          //               border: '1px solid #E8EAEB',
          //               padding: '15px 0px',
          //               marginRight: 15,
          //               fontSize: 14.7,
          //             }}
          //           >
          //             <Row wrap={false}>
          //               <div style={{ width: '33.33333%', padding: '0px 25px' }}>
          //                 <p style={{ fontWeight: 700, marginBottom: 6 }}>
          //                   {t('order_list.order_infomation')}
          //                 </p>
          //                 <Row justify="space-between">
          //                   <div style={{ color: '#747C87' }}>{t('order_list.order_code')}:</div>
          //                   <div>{record.order_id || ''}</div>
          //                 </Row>
          //                 <Row justify="space-between">
          //                   <div style={{ color: '#747C87' }}>{t('common.create_date')}:</div>
          //                   <div>{moment(record.create_date).format('DD/MM/YYYY HH:mm')}</div>
          //                 </Row>
          //                 <Row justify="space-between">
          //                   <div style={{ color: '#747C87' }}>{t('order_list.sales_source')}:</div>
          //                   <div>POS</div>
          //                 </Row>
          //                 <Row justify="space-between">
          //                   <div style={{ color: '#747C87' }}>{t('order_list.salesman')}:</div>
          //                   <div>
          //                     {record.employee
          //                       ? `${record.employee.first_name} ${record.employee.last_name}`
          //                       : ''}
          //                   </div>
          //                 </Row>
          //               </div>
          //               <div
          //                 style={{
          //                   width: '33.33333%',
          //                   padding: '0px 25px',
          //                   borderRight: '1px solid #E8EAEB',
          //                 }}
          //               >
          //                 <p style={{ fontWeight: 700, marginBottom: 6 }}>
          //                   {t('order_list.customer')}
          //                 </p>
          //                 <Row wrap={false} style={{ width: '100%' }}>
          //                   <a>
          //                     {record.customer
          //                       ? `${record.customer.first_name} ${record.customer.last_name}`
          //                       : ''}
          //                   </a>
          //                   <div style={{ margin: '0px 5px', display: !record.customer && 'none' }}>
          //                     -
          //                   </div>
          //                   <div>{record.customer ? record.customer.phone : ''}</div>
          //                 </Row>
          //                 <div>
          //                   {record.customer
          //                     ? `${record.customer.address}, ${record.customer.district}, ${record.customer.province}`
          //                     : ''}
          //                 </div>
          //               </div>
          //               <div style={{ width: '33.33333%', padding: '0px 25px' }}>
          //                 <div style={{ marginBottom: 10 }}>
          //                   <p style={{ fontWeight: 700, marginBottom: 4 }}>
          //                     {t('common.create_date')}
          //                   </p>
          //                   <div style={{ color: record.note ? '' : '#747C87' }}>
          //                     {record.note ? record.note : t('order_list.order_without_notes')}
          //                   </div>
          //                 </div>
          //                 <div>
          //                   <p style={{ fontWeight: 700, marginBottom: 4 }}>
          //                     {t('order_list.tags')}
          //                   </p>
          //                   <div
          //                     style={{
          //                       color: !record.tags || !record.tags.length ? '#747C87' : '',
          //                     }}
          //                   >
          //                     {record.tags && record.tags.length
          //                       ? record.tags.join(',')
          //                       : t('order_list.order_without_tags')}
          //                   </div>
          //                 </div>
          //               </div>
          //             </Row>
          //           </div>
          //           <Space direction="vertical">
          //             <Button
          //               style={{ width: 140 }}
          //               size="large"
          //               type="primary"
          //               onClick={async () => {
          //                 console.log(record)
          //                 setDataPrint({
          //                   ...record,
          //                   isDelivery: record.shipping_info ? true : false,
          //                   deliveryCharges:
          //                     record.shipping_info && (record.shipping_info.cod || 0),
          //                   sumCostPaid: record.total_cost,
          //                   discount:
          //                     record.promotion && Object.keys(record.promotion).length
          //                       ? record.promotion
          //                       : null,
          //                   moneyToBePaidByCustomer: record.final_cost,
          //                   deliveryAddress: record.shipping_info,
          //                   moneyGivenByCustomer: 0,
          //                   prepay: 0,
          //                 })
          //                 await delay(500)
          //                 handlePrint()
          //               }}
          //             >
          //               {t('order_list.order_printing')}
          //             </Button>
          //             {/* <Button style={{ width: 140 }} size="large">
          //               Sửa đơn hàng
          //             </Button> */}
          //           </Space>
          //         </Row>
          //         <div className="table-product-in-order">
          //           <Table
          //             pagination={false}
          //             size="small"
          //             style={{ width: '99%', marginTop: 30 }}
          //             columns={columnsProduct}
          //             dataSource={record.order_details}
          //             summary={() => (
          //               <Table.Summary.Row>
          //                 <Table.Summary.Cell></Table.Summary.Cell>
          //                 <Table.Summary.Cell></Table.Summary.Cell>
          //                 <Table.Summary.Cell></Table.Summary.Cell>
          //                 <Table.Summary.Cell></Table.Summary.Cell>
          //                 <Table.Summary.Cell></Table.Summary.Cell>
          //                 <Table.Summary.Cell colSpan={2}>
          //                   <div style={{ fontSize: 14.7 }}>
          //                     <Row wrap={false} justify="space-between">
          //                       <div>
          //                         {t('order_list.total_cost')} ({record.order_details.length}{' '}
          //                         {t('order_list.dish')})
          //                       </div>
          //                       <div>{record.total_cost ? formatCash(+record.total_cost) : 0}</div>
          //                     </Row>
          //                     <Row wrap={false} justify="space-between">
          //                       <div>{t('order_list.discount')}</div>
          //                       <div>
          //                         {record.promotion
          //                           ? `${formatCash(+(record.promotion.value || 0))} ${record.promotion.type && record.promotion.type !== 'VALUE'
          //                             ? '%'
          //                             : ''
          //                           }`
          //                           : 0}
          //                       </div>
          //                     </Row>
          //                     <Row wrap={false} justify="space-between">
          //                       <div>Phí giao hàng</div>
          //                       <div>
          //                         {record.shipping_info
          //                           ? formatCash(+record.shipping_info.cod || 0)
          //                           : 0}
          //                       </div>
          //                     </Row>
          //                     <Row wrap={false} justify="space-between" style={{ fontWeight: 600 }}>
          //                       <div>{t('order_list.guest_must_pay')}</div>
          //                       <div>
          //                         {record.final_cost ? formatCash(+record.final_cost || 0) : 0}
          //                       </div>
          //                     </Row>
          //                   </div>
          //                 </Table.Summary.Cell>
          //               </Table.Summary.Row>
          //             )}
          //           />
          //         </div>
          //       </div>
          //     )
          //   },
          // }}
          columns={columnsOrder}
          style={{ width: '100%', marginTop: 35 }}
          pagination={{
            current: paramsFilter.page,
            pageSize: paramsFilter.page_size,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showQuickJumper: true,
            onChange: (page, pageSize) => {
              paramsFilter.page = page
              paramsFilter.page_size = pageSize

              setParamsFilter({ ...paramsFilter })
            },
            total: countOrder,
          }}
          scroll={{ x: 'max-content' }}
          dataSource={orders}
          // summary={(pageData) => (
          //   <Table.Summary.Row>
          //     <Table.Summary.Cell>
          //       <b>{t('order_list.total')}</b>
          //     </Table.Summary.Cell>
          //     <Table.Summary.Cell></Table.Summary.Cell>
          //     <Table.Summary.Cell></Table.Summary.Cell>
          //     <Table.Summary.Cell></Table.Summary.Cell>
          //     <Table.Summary.Cell></Table.Summary.Cell>
          //     <Table.Summary.Cell></Table.Summary.Cell>
          //     <Table.Summary.Cell></Table.Summary.Cell>
          //     <Table.Summary.Cell>
          //       {formatCash(tableSum(pageData, 'final_cost'))} {t('common.unit')}
          //     </Table.Summary.Cell>
          //   </Table.Summary.Row>
          // )}
        />
      </div>
    </>
  )
}
